<div
  *ngIf="!loaded && dgCLientService.connected"
  style="width: 100%; height: 100%; min-height: 400px; position: absolute;z-index:1000000"
  class="loader"
>
  <div class="center">
    <h2>Pro-Ject</h2>
    Loading {{ loadedItem }}...
  </div>
</div>
<header
  *ngIf="dgCLientService.connected"
  style="position: absolute; z-index: 100;display:flex;"
>
  <nav
    class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3 p-0"
    style="
      background-color: rgba(255, 255, 255, 0.2) !important;
      border: 0 !important;
    "
  >
    <div *ngIf="!expandMenuPanel && loaded">
      <div *ngIf="false" class="fs alerts">
        <app-signals-visualization></app-signals-visualization>
      </div>
      <div
        class="fs"
        #tooltip="matTooltip"
        matTooltip="Expand"
        (click)="expandMenuPanel = !expandMenuPanel"
        style="background-color: #6c757d; padding-right: 0px"
      >
        <mat-icon class="white-icon">chevron_right</mat-icon>
      </div>
      <div
          class="fs"
          style="padding-left: 10px;"
        >
              <span
              *ngIf="true"
              #tooltip="matTooltip"
              matTooltip="Show UpperScreen Magnituder"
              (click)="settingsService.showUpperMagniture=!settingsService.showUpperMagniture"
            >
              <mat-icon *ngIf="settingsService.showUpperMagniture" class="white-icon">check_box</mat-icon>
              <mat-icon *ngIf="!settingsService.showUpperMagniture" class="white-icon"
                >check_box_outline_blank</mat-icon
              >
            </span>
        </div>
    </div>

    <div *ngIf="expandMenuPanel" [ngClass]="'ss'" class="container p-0">
      <span
        [matMenuTriggerFor]="afterMenu"
        class="menu-item cursor-pointer menu-t-fix ml-2 mr-2 d-inline-block _pt-2"
        style="position: relative; top: 3px; color: #fff"
      >
        <!-- <i class="fa fa-user" aria-hidden="true"></i> -->
        <mat-icon class="hamburger-gear-color">menu</mat-icon>
      </span>
      <div
        class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"
        [ngClass]="{ show: isExpanded }"
      >
        <ul class="navbar-nav flex-grow">
          <li class="nav-item pl-0">
            <ng-container>
              <mat-menu #afterMenu="matMenu" xPosition="after">
                <button (click)="openSettingsWindow()" mat-menu-item>
                  <mat-icon>settings</mat-icon>
                  <span> Settings </span>
                </button>
                <button (click)="openRetracementWindow()" mat-menu-item>
                  <mat-icon>horizontal_split</mat-icon>
                  <span> Retracement Settings </span>
                </button>
                <button (click)="openViewsWindow()" mat-menu-item>
                  <mat-icon>monitor</mat-icon>
                  <span> Views </span>
                </button>
                <button (click)="resetToDefault()" mat-menu-item>
                  <mat-icon>restore</mat-icon>
                  <span> Reset to default </span>
                </button>
                <button (click)="enableIntermediates()" mat-menu-item>
                  <mat-icon *ngIf="!retracementAllowIntermediates"
                    >radio_button_unchecked</mat-icon
                  >
                  <mat-icon *ngIf="retracementAllowIntermediates"
                    >radio_button_checked</mat-icon
                  >
                  <span> The Retracement tool for Intermediates </span>
                </button>
                <button (click)="logout()" mat-menu-item>
                  <mat-icon>exit_to_app</mat-icon>
                  <span> Logout </span>
                </button>

                <button *ngIf="false" (click)="test()" mat-menu-item>
                  <mat-icon>exit_to_app</mat-icon>
                  <span> tt </span>
                </button>
              </mat-menu>
            </ng-container>
          </li>
        </ul>
      </div>
      <a class="navbar-brand" [routerLink]="['/']">Pro-Ject</a>
      <div>
        <div class="fs">
          <app-viewsSelector-dialog
            *ngIf="loaded && dgCLientService.connected"
          ></app-viewsSelector-dialog>
        </div>
        
        <span
          class="fs"
          #tooltip="matTooltip"
          matTooltip="Clear active retracements"
          *ngIf="true"
          (click)="clearRetracements()"
          style="position: relative;"
        >
          <mat-icon class="white-icon">horizontal_split</mat-icon>
          <span style="color: red; font-size: 20px;font-weight:bold; position: absolute; top: 8px; right: 10px;">x</span>
        </span>

        <span
          class="fs"
          #tooltip="matTooltip"
          matTooltip="Show/Hide right sidebar"
          *ngIf="true"
          (click)="hideRightbar()"
          style="position: relative;"
        >
          <mat-icon class="white-icon">account_balance_wallet</mat-icon>
          <span *ngIf="strikesSumService.rightBarsEnabled" style="color: red; font-size: 20px;font-weight:bold; position: absolute; top: 8px; right: 10px;">x</span>
        </span>


        <span
          class="fs"
          #tooltip="matTooltip"
          matTooltip="Save current state as new view"
          *ngIf="true"
          (click)="selectView()"
        >
          <mat-icon class="white-icon">monitor</mat-icon>
        </span>
        <span
          class="fs"
          id="fullscreen"
          #tooltip="matTooltip"
          matTooltip="Enable full screen"
          *ngIf="!isFullScreen"
          (click)="fullscreen()"
        >
          <mat-icon class="white-icon">fullscreen</mat-icon>
        </span>
        <span
          class="fs"
          #tooltip="matTooltip"
          matTooltip="Disable full screen"
          *ngIf="isFullScreen"
          (click)="closeFullscreen()"
        >
          <mat-icon class="white-icon">closefull</mat-icon>
        </span>
        <span
          *ngIf="true"
          #tooltip="matTooltip"
          matTooltip="Show / hide last permanent wave bounds."
          class="fs"
          (click)="lastWaveTrackerState()"
        >
          <mat-icon *ngIf="tracerState" class="white-icon">check_box</mat-icon>
          <mat-icon *ngIf="!tracerState" class="white-icon"
            >check_box_outline_blank</mat-icon
          >
        </span>
        <span
          *ngIf="true"
          #tooltip="matTooltip"
          matTooltip="Add new horizontal price line"
          class="fs"
          [ngClass]="{ priceLineTracer: isPricelIneDrawActive }"
          (click)="addPriceLine()"
        >
          <mat-icon class="white-icon">add</mat-icon>
        </span>
        <span *ngIf="true" class="fs" (click)="changeMagnituderAlertsState()">
          <span
            style="position: relative"
            #tooltip="matTooltip"
            matTooltip="Enable/disable sound signals for selected view"
          >
            <mat-icon class="white-icon">notification_important</mat-icon>
            <span [ngClass]="{ crossed: !alertsEnabled }"></span>
          </span>
        </span>
      </div>
      <div>
        <div *ngIf="loaded&&false" class="fs alerts">
          <app-signals-visualization></app-signals-visualization>
        </div>

        <div
          class="fs"
          #tooltip="matTooltip"
          matTooltip="Collapse"
          (click)="expandMenuPanel = !expandMenuPanel"
          style="background-color: #6c757d; padding-right: 0px"
        >
          <mat-icon class="white-icon">chevron_left</mat-icon>
        </div>
       <div
          class="fs"
          style="padding-left: 10px;"
        >
              <span
              *ngIf="true"
              #tooltip="matTooltip"
              matTooltip="Show UpperScreen Magnituder"
              (click)="settingsService.showUpperMagniture=!settingsService.showUpperMagniture"
            >
              <mat-icon *ngIf="settingsService.showUpperMagniture" class="white-icon">check_box</mat-icon>
              <mat-icon *ngIf="!settingsService.showUpperMagniture" class="white-icon"
                >check_box_outline_blank</mat-icon
              >
            </span>
            <select style="position:relative;top:-7px" [ngModel]="settingsService.diffValue" (change)="onValueChange($event.target.value)">
              <option value='34.5'>
                34.5
              </option>
              <option value='63'>
                  63
              </option>
            </select>
            <select style="position:relative;top:-7px" [ngModel]="settingsService.selectedMinBarRights" (change)="onValueBarRightsChange($event.target.value)">
              <option value=1>
                Default
              </option>
              <option *ngFor="let val of minBarRightsLevels" [value]=val>
                  {{val}}
              </option>

            </select>
            
        </div>
      </div>
    
    </div>
  </nav>
  <div *ngIf="loaded"   class="fs"
  style="padding-left: 10px;">
    <app-spot-ticker></app-spot-ticker>
  </div>
</header>
<div *ngIf="false" style="position:absolute;left:900px;top:20px;z-index:100000;color:#fff;font-size:10px;" id="compBar">
<button (click)="testAddStrike()">TEST ADD</button>
</div>
<!-- Modal content -->
<div *ngIf="loaded && clicked && !timeouted" class="popup">
  <div
    class="row p-2 pt-3"
    (click)="playForUnmute()"
    style="background-color: #353b41;border:1px solid white; padding-right: 10px; padding-left: 10px"
  >
    <div class="col-8">
      <b style="color: #fff; white-space: nowrap; line-height: 20px"
        >Unmute & fullscreen site</b
      >
    </div>

    <div class="col-4">
      <mat-icon *ngIf="clicked" class="white-icon">volume_mute</mat-icon>
      <mat-icon *ngIf="!clicked" class="white-icon">volume_up</mat-icon>
    </div>
  </div>
</div>
<div class="row">
  <div *ngIf="loaded" (click)="settingsService.showEvents=!settingsService.showEvents" style="border:0px" class="clearNots">
    <mat-icon *ngIf="settingsService.showEvents" class="white-icon">check_box</mat-icon>
    <mat-icon *ngIf="!settingsService.showEvents" class="white-icon"
      >check_box_outline_blank</mat-icon
    >
  </div>
  <div *ngIf="loaded" (click)="settingsService.showChartEvent=!settingsService.showChartEvent" style="border:0px" class="clearNots1">
    <mat-icon *ngIf="settingsService.showChartEvent" class="white-icon">check_box</mat-icon>
    <mat-icon *ngIf="!settingsService.showChartEvent" class="white-icon"
      >check_box_outline_blank</mat-icon
    >
  </div>
  <div *ngIf="loaded" style="border:0px" class="clearNots2">
    <select  [ngModel]="settingsService.selectedEventsMode" (change)="onValueselectedEventsMode($event.target.value)">
      <option value="0">Standard</option>
      <option value="1">Advance</option>
    </select>
  </div>

  <!-- <div *ngIf="loaded" style="left:100px;"  (click)="signalService.clearNotes()" class="clearNots">Clear Notifications</div>
  <div *ngIf="loaded" style="left:300px;" (click)="signalService.showAllNotices()" class="clearNots">Show Today's Notifications</div> -->

  
</div>